import type { IconData } from '@stacksjs/iconify-core'

export const shoppingTag: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"m0 8l8 8l8-8V0H8zm12-2.75a1.25 1.25 0 1 0 0-2.5a1.25 1.25 0 0 0 0 2.5\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default shoppingTag
